import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

export const CustomDatePicker = ({ date, setDate, isDisabled }) => {
    const [manualInput, setManualInput] = useState('');
    const [inputError, setInputError] = useState('');

    const handleDateChange = (date) => {
        if(date != null){
            setDate(date);
            setManualInput(''); // Clear manual input when date is selected from the picker
            setInputError(''); // Clear any previous error messages
        }

    };

    const handleInputChange = (event) => {
        const input = event.target.value;
        setManualInput(input);
        // Validate the input format (dd/mm/yyyy)
        const regex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
        if (regex.test(input)) {
            const [_, month, day, year] = input.match(regex);
            const parsedDate = new Date(year, month, day);
            if (!isNaN(parsedDate) && parsedDate != null) {
                setDate(parsedDate);
                setInputError(''); // Clear any previous error messages
            } else {
                setInputError('Invalid date. Please enter a valid date.');
            }
        } else {
            setInputError('Invalid format. Please use dd/mm/yyyy.');
        }
    };

    const formatDate = (date) => {
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based 
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };
    return (
        <DatePicker
            showIcon
            selected={date}
            onChange={handleDateChange}
            customInput={
                <input
                    type="text"
                    selected={manualInput || formatDate(date)}
                    onChange={handleInputChange}
                    placeholder="Enter date (dd/mm/yyyy)"

                />
            }
            showMonthDropdown
            showYearDropdown
            dateFormat="dd/MM/yyyy"
            disabled={isDisabled}
        />

    );
};

export function formatDate(date) {
    if (date === undefined) return "";
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based 
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
}